var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIframeVisible)?_c('iframe',{staticClass:"device-id-cookies-iframe",attrs:{"src":_vm.iframeSrc},on:{"load":_vm.onLoad}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }